<template>
  <div>
    <div class="hero section-type-b bground-config-clean presentation">
      <div class="row section-type-b pt-5">
        <div class="col-12 presentation-inner-padding-top2">
          <div>
            <h1 class="text-center text-light">Planes de financiamiento</h1>
          </div>
          <div class="section-type-c pt-5 mb-64">
            <div class="personal-container fondo">
              <div class="row">
                <Promotion
                  v-bind:key="promotion.idFinanciamiento"
                  v-for="promotion in promotions"
                  :descripcion="promotion.descripcion"
                  :engancheSugerido="promotion.engancheSugerido"
                  :idFinanciamiento="promotion.idFinanciamiento"
                  :idVehiculo="promotion.idVehiculo"
                  :nombre="promotion.nombre"
                  :portada="promotion.portada"
                ></Promotion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Promotion from "@/components/Promotion";

export default {
  name: "Promociones",
  data() {
    return {
      page: 1,
      limit: 12,
      promotions: [],
    };
  },
  components: {
    Promotion,
  },
  async mounted() {
    this.promotions = await this.$http.get(
      `${this.API_URL}/web/finantial/all?page=${this.page}&limit=${this.limit}`
    );
    this.promotions = this.promotions.data.data.elementos;
  },
  methods: {
    async viewMore() {
      this.limit += 3;
      this.promotions = await this.$http.get(
        `${this.API_URL}/web/finantial/all?page=${this.page}&limit=${this.limit}`
      );
      this.promotions = this.promotions.data.data.elementos;
    },
  },
};
</script>

<style scoped>
.fondo {
  background: url(https://www.toptal.com/designers/subtlepatterns/patterns/interlaced.png);
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
}
</style>
